<!-- Tooltip.vue (only the important bits) -->
<template>
  <div ref="trigger" @mouseenter="show" @mouseleave="hide">
    <slot/>

    <portal to="tooltips">
      <transition name="fade">
        <div
            v-if="open"
            ref="bubble"
            class="fixed z-50 whitespace-nowrap rounded bg-black px-2 py-1 text-xs text-white shadow max-w-2xl break-words"
            :style="{ top: pos.top + 'px', left: pos.left + 'px' }"
        >
          {{ label }}
        </div>
      </transition>
    </portal>
  </div>
</template>

<script>
export default {
  props: { label: String, offset: { type: Number, default: 8 } },
  data: () => ({ open: false, pos: { top: 0, left: 0 } }),
  methods: {
    async show() {
      this.open = true
      await this.$nextTick()
      this.updatePos()
      window.addEventListener('scroll', this.updatePos, true)
      window.addEventListener('resize', this.updatePos)
    },
    hide() {
      this.open = false
      window.removeEventListener('scroll', this.updatePos, true)
      window.removeEventListener('resize', this.updatePos)
    },
    updatePos() {
      const t = this.$refs.trigger
      const b = this.$refs.bubble
      if (!t || !b) return

      const r = t.getBoundingClientRect()
      const bw = b.offsetWidth
      const bh = b.offsetHeight
      const vw = window.innerWidth
      const pad = 8

      // Prefer top; flip to bottom if not enough room
      let top = r.top - bh - this.offset+50
      if (top < pad) top = r.bottom + this.offset

      // Center horizontally, then clamp inside viewport
      const centerX = r.left + r.width / 2
      const minX = pad + bw / 2
      const maxX = vw - pad - bw / 2
      const clampedCenterX = Math.max(minX, Math.min(centerX, maxX))
      const left = clampedCenterX - bw / 2

      this.pos = { top, left }
    }
  }
}
</script>